import { configureStore } from '@reduxjs/toolkit';
import { organizationApi } from './organizationApi';
import { contragentApi } from './contragentApi';
import { nomenklaturaApi } from './nomenklaturaApi';
import { functionalityApi } from './functionalityApi';
import { dogovorApi } from './dogovorApi';
import { categoryApi } from './coefficientsApi/categoryApi';
import { k2Api } from './coefficientsApi/k2Api';
import { k1Api } from './coefficientsApi/k1Api';
import { k4Api } from './coefficientsApi/k4Api';
import { k3Api } from './coefficientsApi/k3Api';
import { raschetApi } from './coefficientsApi/raschetApi';
import { kiApi } from './coefficientsApi/kiApi';
import { kzApi } from './coefficientsApi/kzApi';
import { paymentApi } from './paymentApi';
import { paymentCodeApi } from './paymentCodeApi';
import { streetsApi } from './coefficientsApi/streetsApi';
import { authSlice } from './authSlice';


export default configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [contragentApi.reducerPath]: contragentApi.reducer,
    [nomenklaturaApi.reducerPath]: nomenklaturaApi.reducer,
    [functionalityApi.reducerPath]: functionalityApi.reducer,
    [dogovorApi.reducerPath]: dogovorApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [k2Api.reducerPath]: k2Api.reducer,
    [k1Api.reducerPath]: k1Api.reducer,
    [k4Api.reducerPath]: k4Api.reducer,
    [k3Api.reducerPath]: k3Api.reducer,
    [raschetApi.reducerPath]: raschetApi.reducer,
    [kiApi.reducerPath]: kiApi.reducer,
    [kzApi.reducerPath]: kzApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [paymentCodeApi.reducerPath]: paymentCodeApi.reducer,
    [streetsApi.reducerPath]: streetsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(organizationApi.middleware)
      .concat(contragentApi.middleware)
      .concat(nomenklaturaApi.middleware)
      .concat(functionalityApi.middleware)
      .concat(dogovorApi.middleware)
      .concat(categoryApi.middleware)
      .concat(k2Api.middleware)
      .concat(k1Api.middleware)
      .concat(k4Api.middleware)
      .concat(k3Api.middleware)
      .concat(raschetApi.middleware)
      .concat(kiApi.middleware)
      .concat(kzApi.middleware)
      .concat(paymentApi.middleware)
      .concat(paymentCodeApi.middleware)
      .concat(streetsApi.middleware),
});
